<template>
    <div class="barra-lateral-esquerdo">
        <figure @click='deslogar' class="figure-image">
            <div v-if="getDeslog" class="backGroundOrangeRed">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Deslogado</figcaption>
            </div>
            <div v-else class="backgroundGreen">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Logado</figcaption>
            </div>
        </figure>

        <figure @click='messages' class='figure-image messagesChange'>
            <div :class="{'bg-adv': getMessages}">
                <div class="remove-padding">
                    <img src="/imgs/icons/chat-square-text-white.svg" class='img' alt="msg">
					<div class="remove-padding" v-if="(getTotalInQueue > 0 && !getMessages)">
						<span class="num">{{ getTotalInQueue }}</span>
					</div>
                </div>
                <figcaption>Atendimento Online</figcaption>
            </div>
        </figure>

		<figure @click="contacts()" class='figure-image'>
			<div :class="{'bg-adv': getContacts}">
				<img src="/imgs/icons/address-book.svg" class='img'>
				<figcaption>Contatos</figcaption>
			</div>
    	</figure>

		<figure  @click="historicol()" class='figure-image'>
			<div :class="{'bg-adv': getShowHistory}">
				<img src="/imgs/icons/arrow-counterclockwise-white.svg" class='img'>
				<figcaption>Histórico</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" class='figure-image'>
            <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Desligar</figcaption>
            </div>
            <div v-else @click="discar">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Discar</figcaption>
            </div>
        </figure>

		<figure v-if="telefone" @click="pause" class="figure-image">
			<div v-if='getPause' class="backGroundOrange">
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
			</div>
			<div v-else>
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>Pausar</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" @click="mute" class='figure-image'>
			<div v-if='getMute' class="backGroundOrange">
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mudo</figcaption>
			</div>
			<div v-else>
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mute</figcaption>
			</div>
		</figure>

        <figure @click='agendamento' class='figure-image' style="display:none">
            <div class="">
                <img src="/imgs/icons/calendar-date-white.svg" class='img'>
                <figcaption>Agendamento</figcaption>
            </div>
        </figure>
       	<div hidden>{{hue}}</div>
    </div>

</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
	import clientData from '../../store/modules/newConnectLine';
	const parsedTelefone = (process.env.MIX_TELEFONE === 'true');

	const isSSL = (location.hostname == 'localhost')? 'http': 'https';
	const connection = (parsedTelefone) ? io.connect(`${isSSL}://${location.hostname}:3002/`) : { 'on': function() {}, 'emit': function() {} };	
    
	export default {
    data() {
        return {
            interval_pause: '',
            time_pause: '',
            time_pause_format: '00:00:00',
            debugDisc: false,
            total_in_queue: '',
            userQueues: [],
	        queuePause: false,
			telefone: parsedTelefone
        }
    },
    computed: {
        ...mapGetters([
            'getDeslog',
            'getModalPause',
            'getMessages',
            'getOccurrences',
            'getShowHistory',
            'getCnpj',
            'getPause',
            'getMute',
            'getQueues',
            'getExtension',
            'getId',
            'getChannel',
            'getChamada',
            'getCnpj',
            'allClients',
            'getShowSpearhead',
            'getProtocol',
            'getCallTime',
            'getPauseTime',
            'oneClient',
            'getShowBarRight',
            'getTotalMyQueue',
            'getTotalInQueue',
			'getContacts'
        ]),
		hue: function() {
			this.setExtension(user.getExtension())
			this.setQueues(user.getQueue())
			this.setId(user.getId())
		},
    },
    watch: {
        getPauseTime: function() {
            this.validateTimePause();
        },
        time_pause: function () {
            this.time_pause_format = moment.utc(this.time_pause * 1000).format('HH:mm:ss')
        },
		getDeslog(value) {
			if (!value) {
				if (!this.getMessages) {
					this.setMessage();
				}
			} 
			else {
				if (this.getMessages) {
					this.setMessage();
				}
			}
		}
    },
	created() {
		if (!this.getDeslog && !this.getMessages) {
			this.setMessage();
		}

		const filas = user.getQueue();

		if (Array.isArray(filas)) {
			filas.forEach(queue => {
				this.userQueues.push({
					queue: queue,
					logged: false,
					paused: false
				});
			});
		} else if (filas) {
			this.userQueues.push({
				queue: filas,
				logged: false,
				paused: false
			});
		}
	},
    methods: {
		...mapActions([
			'selectPause',
			'sendPauseApi',
			'setOccurrences',
			'setShowHistory',
			'setModalPause',
			'setModalSchedule',
			'settModalCall',
			'setMessage',
			'fetchOcurrences',
			'fetchPauses',
			'comeBack',
			'setDeslog',
			'startOrOut',
			'setMute',
			'setExtension',
			'setQueues',
			'setId',
			'getRealTime',
			'sendUnpause',
			'setChannel',
			'fetchClients',
			'fetchProtocol',
			'setShowSpearhead',
			'chooseClient',
			'chooseClientCnpj',
			'clearAllClients',
			'setCallTime',
			'setPauseTime',
			'saveProduct',
			'clearClient',
			'saveClient',
			'setShowBarRight',
			'checkTotalQUeues',
			'totalMyQueue',
			'setContacts',
			'chooseClientPhone'
		]),
		...mapMutations([
				'setClient',
				'delDataConnectLine'
		]),
		cancelarLogoutDoF5() {
			axios.post('/dialer/cancel-page-logout', {
				extension_line: user.getExtension()
			})
			.catch(() => {});
		},

		salvarEstadoLogin(estaLogado) {
			sessionStorage.setItem(
				'operador_logado',
				estaLogado ? 'true' : 'false'
			);
		},

		restaurarEstadoLogin() {
			const estadoSalvo =
				sessionStorage.getItem('operador_logado');

			console.log('[LOGIN] estado salvo:', estadoSalvo);

			// Se ainda existe como true, a aba provavelmente voltou de um F5.
			// Não mexemos no botão aqui: o estado visual vem do Asterisk.
			if (estadoSalvo === 'true') {
				setTimeout(() => {
					this.cancelarLogoutDoF5();
				}, 700);

				return;
			}

			// Nova aba / sessão sem estado local.
			// Consulta o backend apenas para manter o sessionStorage coerente.
			this.checkLastLoginStatus();
		},

		closeTabLogout() {
			const operadorLogado =
				sessionStorage.getItem('operador_logado');

			if (operadorLogado !== 'true') {
				return;
			}

			const form = new FormData();

			form.append('type', 'LOGOUT_PAGE');

			form.append(
				'extension_line',
				user.getExtension()
			);

			const csrfMeta = document.querySelector(
				'meta[name="csrf-token"]'
			);

			if (csrfMeta) {
				form.append(
					'_token',
					csrfMeta.getAttribute('content')
				);
			}

			navigator.sendBeacon(
				'/dialer/logs',
				form
			);
		},

		async checkLastLoginStatus() {
			try {
				const response =
					await axios.get('/dialer/last-log');

				console.log('[LOGIN] last-log:', response.data);

				if (response.data.system_logout === true) {
					this.salvarEstadoLogin(false);
					return;
				}

				// IMPORTANTE:
				// essa função NÃO muda getDeslog.
				// O visual é controlado pelos eventos QueueMember*.
				this.salvarEstadoLogin(
					response.data.type === 'LOGIN'
				);

			} catch (error) {
				console.error(
					'[LOGIN] Erro ao recuperar último estado:',
					error
				);
			}
		},
		validateTimePause() {
			this.time_pause = (this.getPauseTime != 'null') ? this.getPauseTime : 0;
			if(this.getPauseTime != 'null') {
				this.interval_pause = setInterval(() => {
					this.time_pause++;
				}, 1000);
			} 
			else {
				clearInterval(this.interval_pause);
			}
		},
		historicol(event) {
			if(!this.getDeslog && !this.getShowHistory) {
				this.setShowHistory();
				this.fetchOcurrences(this.getCnpj);
			}
		},
		messages() {
			if(!this.getDeslog && !this.getMessages) this.setMessage();
		},
		discar(event) {
			this.settModalCall();
		},
		getTime() {
			var d = new Date();
			return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
		},
		pause() {
			this.queuePause = false;
			if(this.getPause == true) {
				connection.emit('QueueUnPause', {
					extension: user.getExtension()
				});
			} 
			else {
				if(this.getDeslog == false) {
					this.setModalPause();
					this.fetchPauses();
				}
			}
		},
		agendamento() {
			this.setModalSchedule();
		},
		deslogar() {
			if (!this.telefone) {
				return;
			}

			const filas = user.getQueue();
			const filasUsuario = Array.isArray(filas) ? filas : [filas];

			// O socket espera queues[0] como array de filas (data.queues[0].forEach)
			const data = {
				queues: [filasUsuario],
				extension: user.getExtension(),
			};

			// Está DESLOGADO: solicita login ao Asterisk.
			// Só ficará verde quando o QueueMemberAdded confirmar.
			if (this.getDeslog) {
				console.log('[LOGIN] enviando QueueAdd', data);

				connection.emit('QueueAdd', data);

				return;
			}

			// Está LOGADO: remove das filas onde o Asterisk informou que o ramal está,
			// que podem não estar no cadastro do usuário (ex: fila 'atendimento').
			const filasLogadas = this.userQueues
				.filter(el => el.logged)
				.map(el => el.queue);

			data.queues = [filasLogadas.length ? filasLogadas : filasUsuario];

			// Só ficará deslogado quando todas as filas confirmarem QueueMemberRemoved.
			console.log('[LOGIN] enviando QueueRemove', data);

			if (this.getMessages) {
				this.setMessage();
			}

			if (this.getContacts) {
				this.setContacts();
			}

			if (this.getShowHistory) {
				this.setShowHistory();
			}

			connection.emit('QueueRemove', data);
		},
		mute() {
			//HABILITANDO O MUTE APENAS SE ESTIVER EM LIGAÇÃO
			if(this.getChannel()) {
				this.setMute();

				//COLOCANDO NO LOCALSTORAGE PARA PEGAR INFORMAÇÃO DO MUTE QUANDO ATUALIZAR A PÁGINA
				(this.getMute == true)? localStorage.setItem("mute", "true") : localStorage.removeItem("mute") ;

				//CONTROLANDO SE É PARA COLOCAR O MUTE OU PARA TIRAR E ENVIANDO EMIT NECESSÁRIO
				var stateMute = (this.getMute == true)? 'on' : 'off' ;
				connection.emit('MuteAudio', {
					channel: this.getChannel(),
					extension: user.getExtension(),
					state: stateMute
				});
			}
		},
		async hangup() {
			connection.emit('hangup', {
				channel: this.getChannel()
			})

			//Limpa o canal
			await this.setChannel('');

			//Limpa o ponta de lanca
			await clientData.mutations.delDataConnectLine();
		},
		submitLogin(sub) {
			axios.post('/dialer/logs', {
				type: sub,
				extension_line: user.getExtension()
			})
			.catch((error) => {
				console.error(
					'[LOGIN] Erro ao registrar:',
					error
				);
			});
		},
		contacts() {
			if(!this.getDeslog && !this.getContacts) this.setContacts();
        },
    },
    mounted: function() {
		// RESTAURA LOGIN DEPOIS DO F5
		this.restaurarEstadoLogin();

		// DETECTA FECHAMENTO/REFRESH DA ABA
		window.addEventListener(
			'pagehide',
			this.closeTabLogout
		);

		this.checkTotalQUeues();
		this.totalMyQueue();

		// CAPTURANDO INFORMAÇÕES
		connection.emit('CoreShowChannels', {
			ramal: user.getExtension()
		});

		//EVENTO PARA CAPTURAR DADOS DE LIGAÇÃO EM CURSO DO OPERADOR LOGADO
		connection.on(`CoreShowChannel-${user.getExtension()}`, data => {			
			//HABILITANDO CONTADOR E PASSANDO PRO CONTADOR QUANTO TEMPO ESTA EM LIGAÇÃO
			this.setCallTime(moment.duration(data.Duration).asSeconds());

			//BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
			var self = this;

			this.fetchClients(data.ConnectedLineNum).then(async function() {
				//Recupera os dados tratado
				let phoneSplit = data.ConnectedLineName.split('||');
				let dataPhone = phoneSplit[1];

				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					// self.clearAllClients();
				} else {
					//SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			//SETANDO O CANAL DA LIGAÇÃO ATUAL
			this.setChannel(data.Channel);

			//HABILITANDO O MUTE NOVAMENTE CASO SEJA ATUALIZADO A PÁGINA
			(localStorage.getItem("mute") && this.getChannel() && this.getMute == false)? this.setMute() : false ;
		});

		// HABILITANDO OS BOTÕES NOVAMENTE CASO ESTEJA LOGADO/EM PAUSA.
		// O Asterisk é a fonte da verdade do estado visual.
		connection.on(`QueueMember-${user.getExtension()}`, data => {
			console.log('[QueueMember]', data);

			const queuename = data.Queue;
			let find = this.userQueues.find(el => el.queue === queuename);

			if (!find && queuename) {
				find = {
					queue: queuename,
					logged: false,
					paused: false
				};

				this.userQueues.push(find);
			}

			if (find) {
				find.logged = true;
			}

			if (this.userQueues.some(el => el.logged)) {
				if (this.getDeslog) {
					this.setDeslog();
					this.startOrOut();
				}

				this.salvarEstadoLogin(true);
			}

			if (data.Paused == 1) {
				this.setPauseTime(data.LastPause);
				this.comeBack();

				if (find) {
					find.paused = true;
				}
			}
		});

		// VALIDANDO QUANDO USUÁRIO É INSERIDO NA FILA
		connection.on(`QueueMemberAdded-${user.getExtension()}`, data => {
			console.log('[QueueMemberAdded]', data);

			let find = this.userQueues.find(el => el.queue === data.Queue);

			if (!find && data.Queue) {
				find = { queue: data.Queue, logged: false, paused: false };
				this.userQueues.push(find);
			}

			if (find) {
				find.logged = true;
			}

			if (!this.getDeslog) {
				return;
			}

			this.setDeslog();
			this.startOrOut();

			this.salvarEstadoLogin(true);
			this.submitLogin('LOGIN');

			console.log('[LOGIN] operador logado com sucesso');
		});

		// VALIDANDO QUANDO USUÁRIO É EXPULSO DA FILA
		connection.on(`QueueMemberRemoved-${user.getExtension()}`, data => {
			console.log('[QueueMemberRemoved]', data);

			const find = this.userQueues.find(el => el.queue === data.Queue);

			if (find) {
				find.logged = false;
				find.paused = false;
			}

			// Ainda está em outra fila: continua logado
			if (this.userQueues.some(el => el.logged) || this.getDeslog) {
				return;
			}

			if (this.getPause === true) {
				const time = this.getTime();

				const x = {
					pauseId: data.PausedReason || null,
					tempo: `${time}`,
					userId: this.getId
				};

				this.comeBack(`${time}`);
				this.sendUnpause(x);
				this.setPauseTime('null');
			}

			this.setDeslog();
			this.startOrOut();

			this.salvarEstadoLogin(false);
			this.submitLogin('LOGOUT');

			console.log('[LOGIN] operador deslogado com sucesso');
		});

		// ASTERISK RECUSOU O LOGIN/LOGOUT (ex: membro estático na fila)
		connection.on(`QueueAddError-${user.getExtension()}`, data => {
			console.error('[LOGIN] Asterisk recusou QueueAdd:', data.Message, data);
		});

		connection.on(`QueueRemoveError-${user.getExtension()}`, data => {
			console.error('[LOGIN] Asterisk recusou QueueRemove:', data.Message, data);

			// Continua logado: devolve a tela de atendimentos que foi escondida no clique
			if (!this.getDeslog && !this.getMessages) {
				this.setMessage();
			}
		});

		// Agora que os listeners estão registrados, consulta o estado atual no Asterisk.
		connection.emit('QueueStatus', {
			ramal: user.getExtension()
		});

		// PEGANDO CANAL DO USUÁRIO EM LIGAÇÃO
		connection.on(`NewConnectedLine-${user.getExtension()}`, async data => {
			this.chooseClientPhone('');

			//Trata os dados
			await clientData.mutations.setDataConnectLine(data.ConnectedLineName);

			//Recupera os dados tratado
			let phoneSplit = data.ConnectedLineName.split('||');
			let dataPhone = phoneSplit[1];

			//INICIANDO O CONTADOR COM ZERO
			this.setCallTime(1);

			//BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
			var self = this;
			this.fetchClients(dataPhone).then(function() {
				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					self.clearAllClients();
				} 
				else {
					//SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			//SETANDO CANAL NO STATE
			this.setChannel(data.Channel);
		});

		//DESABILITANDO BOTÃO DE MUTE QUANDO FINALIZADO A LIGAÇÃO
		connection.on(`Hangup-${user.getExtension()}`, async data => {
			this.delDataConnectLine();
			this.setShowSpearhead();
			if(localStorage.getItem("mute")) {
				this.setMute()
				localStorage.removeItem("mute");
			}

			//CADASTRANDO A LIGAÇÃO REALIZADA DO CLIENTE
			var structClient = {
				at_user_id: this.getId,
				protocol: this.getProtocol.protocol,
				uniqueid: data.Linkedid,
				type: 'telefonia',
				created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
				updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
			};

			structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
			this.saveClient(structClient);
			this.setCallTime('null');
			this.clearClient();
			this.clearAllClients();
			this.setChannel('');

			//LIMPANDO O CAMPO DE PRODUTO
			$('.select2-multi').val('-1').trigger('change');

			//Limpa o ponta de lanca
			await clientData.mutations.delDataConnectLine();
		});

		connection.on(`QueueMemberPause-${user.getExtension()}`, data => {
			if(this.queuePause) return;
			this.queuePause = true;

			// Entrou em pausa
			if(data.Paused == 1) {
				this.setPauseTime(0);
				var time = this.getTime();
				var x = {
					"pauseId": data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}

				this.sendPauseApi(x);
				this.selectPause(x);
			}

			// Saiu da pausa
			if(data.Paused == 0) {
				var time = this.getTime();
				var x = {
					"pauseId":data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}
				
				this.comeBack(`${time}`);
				this.sendUnpause(x);
				this.setPauseTime('null');
			}
		});
    },
	beforeDestroy() {
		window.removeEventListener(
			'pagehide',
			this.closeTabLogout
		);

		if (this.interval_pause) {
			clearInterval(this.interval_pause);
		}
	}
}

</script>

<style scoped>
    .num {
        width: 25px;
        height: 25px;
        text-align: center;
        text-combine-upright: all;
        left: 4em;
        border-radius: 50%;
        line-height: 25px;
        color: white;
        background-color: red;
        top: 5.5em;
        position: absolute;
    }

    .barra-lateral-esquerdo {
        background-color: #CCCCCC;
        width: 100%;
        max-width: 99px;
        text-align: center;
        border-right: solid 1px #1C869A;
         min-height: 100%;
        height: calc(100vh - 4.5em);
			overflow: auto;
    }

	::-webkit-scrollbar {
		width: 0.18rem;
	}

	::-webkit-scrollbar-track {
		background: #f38630;
	}

	::-webkit-scrollbar-thumb {
		background: #1c869a;
	}

    .figure-image {
        margin: 0px;
        display: block;
    }

    .figure-image div {
        margin: 0px;
        padding: 9px 0 9px 0;

    }

    .figure-image figcaption {
        color:white
    }

    .backGroundOrangeRed {
        background-color: orangered;
    }

    .backGroundOrange {
        background-color: #fea33b;
    }

    .bg-adv {
        background: #1c869a;
    }

    .backgroundGreen {
        background: #27ae60;
    }

    .count-msg {
        padding: 0px;
        color: white;
        font-size: 1.5em;
    }

    strong .count-msg {
        font-size: 1.5em;
    }

    .remove-padding {
        padding: 0 !important;
    }
</style>



